/**
 * Paths in the Chakra UI base theme that should be excluded
 * from the final DLS theme. This helps prevent influence of
 * unused or unwanted components on new DLS components.
 *
 * Uses lodash.get notation for specifying nested paths.
 * Examples:
 * - 'components.Button.variants.solid'
 * - 'components.Input.sizes.xl'
 * - 'colors.gray.50'
 */
export const EXCLUDED_BASE_THEME_PATHS: string[] = [
  // Add paths here to exclude from the base theme
  // Example:
  // 'components.Button.variants.unstyled',
  // 'components.Input.sizes.xs',
  'semanticTokens.colors',
  'components.Tag.variants',
  'components.Tag.sizes',
];
